// --- 招接待 --- //

export default [
  {
    name: 'reserveInfo',
    path: '/receptionSystem/reserveInfo',
    meta: { title: '招接待' },
    component: require('business/receptionSystem/reserveInfo/list.vue').default
  }

]
